var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _g3, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 24,
    viewBox: "0 0 127 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3297_1011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 5,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.633 12.7992L126.81 5.7025L123.24 5.65466L118.987 10.4954L114.764 5.68531L111.286 5.7025L117.327 12.7992L111.133 19.9731H114.823L118.99 14.9415L123.12 19.9314H126.841L120.633 12.7992Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3297_1011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.637 5.94312H113.566V6.20076H142.637V5.94312Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 6.54443H113.566V6.80208H142.637V6.54443Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 7.14539H113.566V7.40303H142.637V7.14539Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 7.7467H113.566V8.00435H142.637V7.7467Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 8.34766H113.566V8.6053H142.637V8.34766Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 8.9491H113.566V9.20674H142.637V8.9491Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 9.55005H113.566V9.80769H142.637V9.55005Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 10.1514H113.566V10.409H142.637V10.1514Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 10.7523H113.566V11.01H142.637V10.7523Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 11.3536H113.566V11.6113H142.637V11.3536Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 11.9547H113.566V12.2124H142.637V11.9547Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 12.556H113.566V12.8137H142.637V12.556Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 13.157H113.566V13.4146H142.637V13.157Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 13.7583H113.566V14.0159H142.637V13.7583Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 14.3593H113.566V14.6169H142.637V14.3593Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 14.9606H113.566V15.2182H142.637V14.9606Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 15.5616H113.566V15.8193H142.637V15.5616Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 16.163H113.566V16.4206H142.637V16.163Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 16.7639H113.566V17.0216H142.637V16.7639Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 17.3652H113.566V17.6229H142.637V17.3652Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 17.9662H113.566V18.2238H142.637V17.9662Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 18.5676H113.566V18.8253H142.637V18.5676Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 19.1686H113.566V19.4262H142.637V19.1686Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.637 19.7699H113.566V20.0275H142.637V19.7699Z",
    fill: "#683FEA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2233 11.3539V10.3347C43.2233 9.97107 43.1838 9.61698 43.1086 9.27716C42.7303 7.56771 41.4558 6.22153 39.836 5.82267C39.5142 5.7427 39.1787 5.70105 38.834 5.70105H30.5053C29.3482 5.70105 28.4102 6.63909 28.4102 7.79622V15.3919C28.4102 15.6218 28.4261 15.8479 28.4567 16.0688C28.4746 16.1975 28.4977 16.3248 28.5249 16.4499C28.9032 18.1599 29.9161 19.4852 31.5355 19.8845C31.7133 19.9283 31.8949 19.9605 32.0803 19.9809C32.2303 19.9973 32.3828 20.0057 32.5371 20.0057H42.4855C42.8929 20.0057 43.2233 19.6754 43.2233 19.2679V16.4616H40.2838V16.9997C40.2838 17.1896 40.1299 17.3435 39.9401 17.3435H33.9531C33.8524 17.3435 33.7528 17.338 33.6549 17.3273C33.5338 17.314 33.4153 17.2929 33.2991 17.2643C32.2419 17.0037 31.4096 16.3047 31.1626 15.1882C31.1448 15.1065 31.1297 15.0234 31.1181 14.9394C31.0981 14.7952 31.0877 14.6476 31.0877 14.4975V8.67438C31.0877 8.40341 31.3074 8.18374 31.5783 8.18374H37.696C37.921 8.18374 38.14 8.21093 38.3501 8.26313C39.4077 8.52354 40.2398 9.40244 40.4867 10.5185C40.5358 10.7404 40.5616 10.9716 40.5616 11.209V11.3539L43.2233 11.3539Z",
    fill: "#100459"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5926 10.3425V11.8032C72.5926 12.1583 72.555 12.504 72.4829 12.8364C72.481 12.8448 72.4793 12.8526 72.4774 12.8612C72.0997 14.5707 71.1264 15.5302 69.5065 15.9288C69.3287 15.973 69.1466 16.0055 68.9613 16.0258C68.8111 16.0422 68.6588 16.0507 68.5046 16.0507L62.2437 16.0427V20.0057H59.582V5.70105L68.2034 5.7088C68.548 5.7088 68.8836 5.75045 69.2053 5.83042C70.8252 6.22929 72.0997 7.57546 72.4779 9.28492C72.5531 9.62473 72.5926 9.97883 72.5926 10.3425ZM68.554 13.3874C69.2735 13.3874 69.8567 12.7715 69.8567 12.0115L69.9239 9.78532C69.9239 9.0259 69.3407 8.41001 68.6212 8.41001L62.3109 8.40225L62.2437 13.3797L68.554 13.3874Z",
    fill: "#100459"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0043 8.28423H81.9296V19.9215H79.241V8.28423H73.8125V5.61682H87.0043V8.28423Z",
    fill: "#100459"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3297_1011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 5,
    width: 4,
    height: 16
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.635 20.0056V5.73499H103.155V20.0056H100.635Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3297_1011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.055 5.70862H86.9844V5.96626H116.055V5.70862Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 6.30969H86.9844V6.56733H116.055V6.30969Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 6.91101H86.9844V7.16865H116.055V6.91101Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 7.51196H86.9844V7.7696H116.055V7.51196Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 8.11328H86.9844V8.37092H116.055V8.11328Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 8.71423H86.9844V8.97188H116.055V8.71423Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 9.31567H86.9844V9.57332H116.055V9.31567Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 9.91663H86.9844V10.1743H116.055V9.91663Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 10.5179H86.9844V10.7756H116.055V10.5179Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 11.1189H86.9844V11.3765H116.055V11.1189Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 11.7202H86.9844V11.9779H116.055V11.7202Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 12.3213H86.9844V12.5789H116.055V12.3213Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 12.9226H86.9844V13.1802H116.055V12.9226Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 13.5236H86.9844V13.7812H116.055V13.5236Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 14.1249H86.9844V14.3825H116.055V14.1249Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 14.7258H86.9844V14.9835H116.055V14.7258Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 15.3271H86.9844V15.5848H116.055V15.3271Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 15.9282H86.9844V16.1859H116.055V15.9282Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 16.5295H86.9844V16.7872H116.055V16.5295Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 17.1305H86.9844V17.3881H116.055V17.1305Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 17.7318H86.9844V17.9895H116.055V17.7318Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 18.3328H86.9844V18.5904H116.055V18.3328Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 18.9342H86.9844V19.1918H116.055V18.9342Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.055 19.5355H86.9844V19.7932H116.055V19.5355Z",
    fill: "#683FEA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3297_1011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 5,
    width: 15,
    height: 16
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.226 13.5583L94.1398 13.3391L93.5927 11.947L92.4924 9.1481H92.0692L90.969 11.947L90.4217 13.3391L89.3215 16.138L87.7948 20.0227H85.0059L87.1178 14.6489L88.5235 11.0728L89.2228 9.29413L90.6285 5.71802H92.0409H93.9771L95.3829 9.29413L96.0819 11.0728L97.4877 14.6489L99.6 20.0227H96.767L95.2401 16.138L95.1869 16.0028",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3297_1011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.307 5.7323H76.2363V5.98994H105.307V5.7323Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 6.33362H76.2363V6.59126H105.307V6.33362Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 6.93457H76.2363V7.19221H105.307V6.93457Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 7.53589H76.2363V7.79353H105.307V7.53589Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 8.13684H76.2363V8.39448H105.307V8.13684Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 8.73828H76.2363V8.99592H105.307V8.73828Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 9.33923H76.2363V9.59688H105.307V9.33923Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 9.94055H76.2363V10.1982H105.307V9.94055Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 10.5415H76.2363V10.7991H105.307V10.5415Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 11.1428H76.2363V11.4005H105.307V11.1428Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 11.7441H76.2363V12.0018H105.307V11.7441Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 12.3452H76.2363V12.6029H105.307V12.3452Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 12.9465H76.2363V13.2042H105.307V12.9465Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 13.5475H76.2363V13.8051H105.307V13.5475Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 14.1488H76.2363V14.4064H105.307V14.1488Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 14.7498H76.2363V15.0074H105.307V14.7498Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 15.3512H76.2363V15.6088H105.307V15.3512Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 15.9521H76.2363V16.2098H105.307V15.9521Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 16.5535H76.2363V16.8111H105.307V16.5535Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 17.1544H76.2363V17.4121H105.307V17.1544Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 17.7557H76.2363V18.0134H105.307V17.7557Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 18.3568H76.2363V18.6145H105.307V18.3568Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 18.9581H76.2363V19.2158H105.307V18.9581Z",
    fill: "#683FEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.307 19.5591H76.2363V19.8167H105.307V19.5591Z",
    fill: "#683FEA"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8401 13.3323L52.3238 11.9094L51.1879 8.90655H51.609L50.4869 11.9402L49.9396 13.3323L48.8393 16.1312L47.3127 20.0158H44.4023L46.5557 14.5861L47.9615 11.0099L48.6607 9.23128L50.0483 5.70105L51.5588 5.7112L52.7706 5.70612L54.1764 9.28224L54.8754 11.0609L56.2812 14.637L58.3935 20.0108L55.4673 20.0158L53.9403 16.1312L53.8872 15.996",
    fill: "#100459"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.432 5.79056L111.442 16.5043L104.202 5.72122L103.598 5.70874L103.598 9.47184L110.417 20.0195L114.1 19.9541V5.78656L111.432 5.79056Z",
    fill: "#100459"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9081 2.37255L17.8558 12.5408L15.5417 17.1984L14.206 19.8864L14.1856 19.88C14.1304 19.9804 14.0727 20.0792 14.0132 20.1765C13.3938 21.1937 12.5477 22.0545 11.5503 22.6856C10.3955 23.4127 9.03481 23.8333 7.57867 23.8333C5.05682 23.8333 2.82321 22.573 1.44515 20.6346C0.535298 19.3548 0 17.7797 0 16.0777C0 16.0698 -3.02993e-07 16.0616 0.000304497 16.0536C0.00304906 15.0514 0.192462 14.093 0.533773 13.2146C0.648154 12.9184 0.780225 12.6308 0.928766 12.3538C0.930596 12.3502 0.932427 12.3465 0.934562 12.3431L1.11452 12.0262L3.60343 7.64136H3.60373L6.75697 1.90588L9.32488 6.37616L9.09337 6.79525L8.74413 7.42694L8.22805 8.35052C8.22988 8.35082 8.23171 8.35082 8.23354 8.35113L5.16175 13.9091L4.51512 15.0782C4.38976 15.4766 4.33882 15.9094 4.37512 16.3593C4.50017 17.9225 5.72358 19.1953 7.24895 19.3508C7.82085 19.4091 8.36591 19.3139 8.84967 19.1004C9.49904 18.8134 10.0243 18.294 10.3665 17.6605L10.5706 17.2825L12.1853 14.2925L12.9399 12.6689L15.2318 7.73591L17.7234 2.37255L22.9081 2.37255Z",
    fill: "#100459"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7446 7.42725L8.23401 8.35144C8.23218 8.35113 8.23035 8.35113 8.22852 8.35083L8.7446 7.42725Z",
    fill: "#100459"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11355 12.0264L0.933594 12.3433C0.990934 12.2359 1.05102 12.1304 1.11355 12.0264Z",
    fill: "#100459"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2307 7.73599L12.9388 12.669L9.32377 6.37624L6.75586 1.90596C7.93047 -0.197724 10.8986 -0.186437 12.0576 1.92639L15.2307 7.73599Z",
    fill: "#683FEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1137 24.0001H19.4482L15.541 17.1986L17.8552 12.541L24.1137 24.0001Z",
    fill: "#683FEA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.933834 12.3433C0.931699 12.3466 0.929869 12.3503 0.928039 12.3539H0.927734L0.933834 12.3433Z",
    fill: "#100459"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1126 0.00146484L23.9705 0.28025H18.666L18.795 0.00146484H24.1126Z",
    fill: "#683FEA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7814 0.652222L23.6392 0.931003H18.3652L18.4943 0.652222H23.7814Z",
    fill: "#683FEA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4498 1.30273L23.3073 1.58152H18.0645L18.1935 1.30273H23.4498Z",
    fill: "#683FEA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1179 1.95325L22.9757 2.23203H17.7637L17.8927 1.95325H23.1179Z",
    fill: "#683FEA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1178 1.95325L22.9756 2.23203L17.7617 2.236L17.7635 2.23203L17.8926 1.95325H23.1178Z",
    fill: "#683FEA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4498 1.30273L23.3073 1.58152H18.0645L18.1935 1.30273H23.4498Z",
    fill: "#683FEA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7814 0.652222L23.6392 0.931003H18.3652L18.4943 0.652222H23.7814Z",
    fill: "#683FEA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1136 0L24.1126 0.00152353L23.9705 0.280308H18.666L18.795 0.00152353L18.7956 0H24.1136Z",
    fill: "#683FEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.822aea40792eee6da1d7f7025ac95647.svg";
export { ForwardRef as ReactComponent };